/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import logo from "./customer-everlane.svg";
import Company from "./company";
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      strong: "strong",
      blockquote: "blockquote"
    }, props.components), {Header} = _components;
    if (!Header) _missingMdxReference("Header", true);
    return _jsxs(_Fragment, {
      children: [_jsxs("article", {
        children: [_jsx(Header, {}), _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "A typical week:"
          }), " We’re in the midst of rethinking the look and story of our products, and of finalizing our first impact report. But we also have weekly carbon meetings based on the insights we get from Watershed, and are constantly thinking about how to streamline our global supply chain."]
        }), _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "My career path:"
          }), " I don’t have a background in apparel or climate. I’d planned to be an orthopedic surgeon! When I started here, the company was approximately 25-30 people and very few brands in the industry were talking about sustainability—and now my team alone is larger than that. I don’t think it matters what your education or background is. Being a good sustainability champion is about being inquisitive: asking good questions and actively listening."]
        }), _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "I’m optimistic because:"
          }), " It takes work to stay positive right now. Supply chains are in a tough place. But this new attention has upsides: our grandparents are talking about supply chains and container ships now, and there’s a much greater understanding of supply chain impact. And this impact can be positive, where every positive change ripples across the world."]
        })]
      }), "\n", _jsxs(Company, {
        name: "Everlane",
        logo: logo,
        children: [_jsx(_components.p, {
          children: "Bringing radical transparency to the fashion industry to help customers make informed decisions around ethics and sustainability."
        }), _jsx(_components.p, {
          children: "Working with the Science Based Targets initiative (SBTi) to ensure they’re cutting their full share of emissions."
        })]
      }), "\n", _jsxs(_components.blockquote, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Sustainability isn’t just a cost now. The industry is able to use it as ", _jsx("mark", {
            children: "a revenue and a growth vehicle"
          }), "."]
        }), "\n"]
      })]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
